import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import axios from "axios";
import { API_BASE } from "@/lib/track";
import { LogoMark } from "@/components/Logo";
import QuizResultView from "@/components/QuizResult";

export default function QuizResultPage() {
  const [params] = useSearchParams();
  const id = params.get("id") || "";
  const [state, setState] = useState("loading");
  const [result, setResult] = useState(null);

  useEffect(() => {
    if (!id) {
      setState("error");
      return;
    }
    axios
      .get(`${API_BASE}/quiz/results/${id}`)
      .then(({ data }) => {
        setResult(data);
        setState("ok");
      })
      .catch(() => setState("error"));
  }, [id]);

  return (
    <div className="min-h-screen bg-obsidian px-5 py-16 sm:py-20 grain">
      <div className="max-w-3xl mx-auto">
        <Link
          to="/"
          data-testid="quiz-result-home-link"
          className="inline-flex items-center gap-2 text-sm text-slate-300 hover:text-gold transition-colors"
        >
          All In Hand Marketing
        </Link>

        {state === "loading" && (
          <div className="mt-24 flex justify-center">
            <Loader2 className="w-6 h-6 animate-spin text-gold" />
          </div>
        )}

        {state === "error" && (
          <div className="mt-16 rounded-3xl border border-slate-700/60 bg-obsidian-800/60 p-10 text-center" data-testid="quiz-result-error">
            <LogoMark className="w-12 h-12 mx-auto" />
            <h1 className="font-display text-2xl font-bold text-white mt-6">Result link not found</h1>
            <p className="text-slate-400 text-sm mt-3 leading-relaxed">
              This result link is not valid or has been removed. You can retake the Marketing Foundations Check any
              time — it is free and takes about two minutes.
            </p>
            <Link
              to="/quiz"
              data-testid="quiz-retake-link"
              className="inline-block mt-6 rounded-full bg-gold text-obsidian font-display font-bold px-8 py-4 hover:bg-gold-bright transition-colors"
            >
              Retake the Check
            </Link>
          </div>
        )}

        {state === "ok" && result && (
          <>
            <LogoMark className="w-12 h-12" />
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold mt-6">Marketing Foundations Check</p>
            <h1 className="font-display text-3xl sm:text-4xl font-bold text-white mt-3" data-testid="quiz-result-greeting">
              {result.first_name ? `${result.first_name}'s result` : "Your result"}
            </h1>
            <QuizResultView result={result} />
          </>
        )}
      </div>
    </div>
  );
}
